import { get } from "lodash";
import * as yup from "yup";
import { isPpeEndDateBeforeStart } from "screens/Private/Broker/Subscription/Detail/Templates/Acoris/Widgets/AdditionalInformation/ppeDeclaration";

const validator = (messages) => {
  return yup.object().shape({
    ria: yup.boolean(),
    contract: yup.object().shape({}),
    contact: yup.object().shape({
      politicallyExposedPerson: yup
        .boolean()
        .oneOf([true, false])
        .typeError(messages.REQUIRED)
        .required(),
      fields: yup.object().shape({
        ppeFunction: yup
          .string()
          .nullable()
          .test("ppe-function", messages.REQUIRED, function (value) {
            const root = this.from[this.from.length - 1].value;
            if (get(root, "contact.politicallyExposedPerson") !== true) {
              return true;
            }
            return Boolean(value && String(value).trim());
          }),
        ppeStartDate: yup
          .mixed()
          .nullable()
          .test("ppe-start", messages.REQUIRED, function (value) {
            const root = this.from[this.from.length - 1].value;
            if (get(root, "contact.politicallyExposedPerson") !== true) {
              return true;
            }
            return Boolean(value);
          }),
        ppeEndDate: yup
          .mixed()
          .nullable()
          .test(
            "ppe-end-after-start",
            messages.ACORIS?.PPE_END_BEFORE_START,
            function (value) {
              return !isPpeEndDateBeforeStart(this.parent.ppeStartDate, value);
            },
          ),
      }),
    }),
    fields: yup.object().shape({
      familyStatus: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      birthCountry: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      birthCity: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      nationality: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      activityStatus: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      profession: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
    }),
    terminationRequest: yup.mixed().nullable().notRequired(),
  });
};

export default validator;
